import { doc, deleteDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { deleteContentBlocksModuleImages } from "./deleteContentBlocksModuleImages";

type Params = {
  brandId: string;
  pageId: string;
  moduleId: string;
};

export const deletePageModule = async (params: Params): Promise<void> => {
  const moduleRef = doc(
    db,
    `brands/${params.brandId}/pages/${params.pageId}/modules/${params.moduleId}`,
  );

  await deleteContentBlocksModuleImages({ ...params, moduleRef });

  await deleteDoc(moduleRef);
};
